import { cn } from "@/lib/components";
import { Spinner } from "../base/spinner";

export function LoadingOverlay() {
  return (
    <div
      className={cn(
        "absolute top-0 left-0 h-full w-full bg-black/50",
        "flex items-center justify-center",
      )}
    >
      <Spinner className="size-20 text-white/50" />
    </div>
  );
}
